import angular from 'angular';

export default angular.module('shared').constant('sessionStorageConstants', {
    sessionType: 'session_type',
    tokenBilling: 'token_billing'
});



// WEBPACK FOOTER //
// ./modules/shared/constants/sessionStorage.constant.js